import { Controller } from 'stimulus';

class Zoom extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    import('lightbox2').then((module) => {
      const lightbox = module.default;

      lightbox.option({
        albumLabel: this.element.dataset.lightboxLabel,
        disableScrolling: true,
        showImageNumberLabel: false,
        positionFromTop: 120,
      });
    });
  }
}

Zoom.targets = [
  //
];

export default Zoom;
